<template>
  <div :class="['shift-detail-row-icon', noBorder && 'no-border', multiLine && 'multi-line']">
    <component class="icon" :is="icon" />
    <div class="text">
      <slot>{{text}}</slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Component as ComponentType } from 'vue';

defineProps<{
  icon: ComponentType;
  text?: string;
  noBorder?: boolean
  multiLine?: boolean;
}>();
</script>
<style lang="scss">
.shift-detail-row-icon {
  width: 100%;
  background-color: var(--pidz-white);

  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: solid 1px var(--pidz-grey-light);
  color: var(--pidz-black);

  &.no-border {border-bottom: none; }

  &.multi-line {
    padding: 12px 24px 12px 0;

    .icon {
      align-self: flex-start;
    }
  }

  .icon {
    flex-shrink: 0;
    margin: 0 18px;
    width: 30px;
    height: 30px;
    color: var(--pidz-blue)
  }

  .text {
    span {
      display: block;
    }

    .bold {
      font-weight: 600;
    }
  }
}
</style>
